export default __webpack_public_path__ + "static/media/services4.da9513b4.jpg";